"use strict";
import axios from "axios";
import GBLVAR from "../GlobalVariables/GlobalVariables";
import cookie from "react-cookies";
import {deleteAllCookies, sessionStorageGetItem, sessionStorageRemoveItem} from "./Utils"
class ApiCall {  
  get(url, callback) {
    this.callApiRequest(url, null, 0,callback);
  }

  post(url, data, callback) {
    this.callApiRequest(url, data, 1,callback);
    console.log(callback,"data")
  }

  patch(url, data, callback) {
    this.callApiRequest(url, data, 2,callback);
  }

  put(url, data, callback) {
    this.callApiRequest(url, data, 4,callback);
  }

  delete(url, data, callback) {
    this.callApiRequest(url, data, 3,callback);
  }   

  callApiRequest(append, data, type, callback) {

    var instance = axios.create();
    instance.defaults.headers.post["Content-Type"] = "application/json";
    instance.defaults.headers.common["Authorization"] = "Bearer " + sessionStorageGetItem("MerchantAuthPayout");
    // instance.defaults.headers.common["x-consumer-username"] = "merchant_lnBTK1IAt3";
    // instance.defaults.headers.common["x-consumer-username"] = sessionStorageGetItem("merchant_o6dQxWs73C");
    var url = GBLVAR.BASE_URL + append;
    // }
    // else{
    //   url = GBLVAR.BASE_URL + append;
    // }
    var task;
    switch (type) {
      case 0:
        task = instance.get(url);
        break;
      case 1:
        task = instance.post(url, data);
        break;
      case 2:
        task = instance.patch(url, data);
        break;
      case 3:
        task = instance.delete(url, data);
        break;
      case 4:
        task = instance.put(url, data);
        break;
      default:
        task = instance.delete(url, data);
        break;
    }

    task
      .then(result => {
        callback(result.data);
      })
      .catch(error => {
        if (error && error.response && error.response.status === 401) {
          callback(error.response.data);
          deleteAllCookies();
          sessionStorageRemoveItem("auth_merchant_id");
          sessionStorageRemoveItem("MerchantAuthPayout");
          window.location.href = `/signin`;
        }
        if (error?.response?.status >= 400) {
          callback(error.response.data);
        }
   
      });
  }
}

export default new ApiCall();